import React, { useContext } from 'react';
import { DetailContext, DetailHandle } from '@eas/common-web';
import { EsFile } from '@models';
import { usePlenaryOpinionPermission } from '../../../es-file/es-file-permission';
import { DecisionFields } from '../../../es-file/fields/decisions/decisions';

export function DecisionsFields() {
  const { source } = useContext<DetailHandle<EsFile>>(DetailContext);

  const { hasPermission } = usePlenaryOpinionPermission(source.data);

  return (
    <>
      <DecisionFields hasPermission={hasPermission} />
    </>
  );
}
